import { render, staticRenderFns } from "./ChangeEmailScreen.vue?vue&type=template&id=28281764&"
import script from "./ChangeEmailScreen.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports